module.exports = "data:image/svg+xml;base64,PHN2ZyB0PSIxNzI4NDYwMjc4MTI4IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjU1MzgiIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PHBhdGggZD0iTSAxMDE0LjY1IDk2Ny4yNTkgTCA3MDguMjU2IDY2MC44NiBhIDQwMC41MjIgNDAwLjUyMiAwIDEgMCAtNDcuMzk1IDQ3LjM5NSBsIDMwNS43MzEgMzA1LjczMSBhIDMzLjM3NjggMzMuMzc2OCAwIDAgMCA0Ny4zOTUgLTQ3LjM5NSBaIE0gMTY0Ljg4MSA2MzguODMyIGEgMzMzLjc2OCAzMzMuNzY4IDAgMSAxIDQ3My45NSAwIGEgMzMzLjc2OCAzMzMuNzY4IDAgMCAxIC00NzMuOTUgMCBaIiBmaWxsPSIjZmZmZmZmIiBwLWlkPSI1NTM5Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search.svg
// module id = PqKd
// module chunks = 16